import { useQuery } from "urql";

import {
  GetPaymastersDocument,
  PaymasterFilter,
  PaymasterOrderBy,
} from "../../../graphql/generated.ts";
import { getApiPaginationData } from "../../../utils/api.ts";
import { ApiHookProps } from "../types.ts";

export const usePaymasters = ({
  filter,
  orderBy,
  pause,
  page,
}: ApiHookProps<PaymasterFilter, PaymasterOrderBy>) => {
  const pagination = getApiPaginationData(page);
  const variables = {
    filter,
    orderBy,
    skip: pagination?.skip,
    take: pagination?.take,
  };
  return useQuery({ query: GetPaymastersDocument, variables, pause });
};
